import React from "react";
import { motion } from "framer-motion";
import { Ruler, ShieldCheck, Users, Headphones } from "lucide-react";
import { useTranslation, Trans } from "react-i18next";

const ITEMS = [
  { key: "sizes", icon: Ruler },
  { key: "quality", icon: ShieldCheck },
  { key: "family", icon: Users },
  { key: "support", icon: Headphones },
];

export const Features = () => {
  const { t } = useTranslation();

  return (
    <section
      id="diferenciais"
      data-testid="features-section"
      className="py-24 md:py-32 max-w-7xl mx-auto px-6 lg:px-10"
    >
      <div className="max-w-2xl mb-14">
        <span className="font-body uppercase tracking-[0.28em] text-xs text-[#C86A3D] font-semibold">
          {t("features.eyebrow")}
        </span>
        <h2 className="font-display font-black tracking-tight text-4xl md:text-5xl text-[#1A1A1A] mt-4 leading-tight">
          <Trans
            i18nKey="features.title"
            components={{
              em: (
                <span className="font-serif-editorial italic font-normal text-[#2A3563]" />
              ),
            }}
          />
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {ITEMS.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.key}
              data-testid={`feature-${f.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white border border-[#E5E5E0] rounded-sm p-7 hover:border-[#2A3563] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-sm bg-[#2A3563]/8 flex items-center justify-center mb-5">
                <Icon className="text-[#2A3563]" size={24} />
              </div>
              <h3 className="font-display font-bold text-xl text-[#1A1A1A]">
                {t(`features.items.${f.key}.title`)}
              </h3>
              <p className="font-body text-sm text-[#1A1A1A]/65 mt-3 leading-relaxed">
                {t(`features.items.${f.key}.desc`)}
              </p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
